import { AuthXInterceptor } from '../Config/AuthXInterceptor'

const BASE_URL = process.env.REACT_APP_BX_BASE_URL || ''

export interface SendNotificationPayload {
  title: string
  body: string
  targetType?: string
  targetUserResourceId?: string
  targetUserResourceIds?: string[]
}

export const notificationBXService = {
  // Send notification
  send: async (payload: SendNotificationPayload) => {
    return AuthXInterceptor.post('notifications/send', payload)
  },

  // Get all notifications
  index: async (params?: { page?: number; limit?: number; sortOrder?: 'ASC' | 'DESC' }) => {
    return AuthXInterceptor.get('notifications', {
      params,
    })
  },

  // Get single notification
  show: async (notificationId: string) => {
    return AuthXInterceptor.get(`notifications/${notificationId}`)
  },
}
